import BaseService from '@/services/BaseService'

class ProductService {

    constructor() {
        this._httpService = new BaseService();
    }


    getProductOptimization(optimizationGuid) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/product-management/product-optimization/${optimizationGuid}`,
            method: 'GET'
        }
        console.info('optimizationGuid')
        return this._httpService.service(settings)
    }

}

export default ProductService